import React from "react";
import HeroV2 from "../HeroV2/HeroV2";
import GeneticPotential from "../GeneticPotential/GeneticPotential";
import CustomerFeedback from "../CustomerFeedback/CustomerFeedback";

const HomePageV2 = () => {
  return (
    <>
      <HeroV2 />
      <GeneticPotential />
      <CustomerFeedback />
    </>
  );
};

export default HomePageV2;
